import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import TitleBlock from '../components/TitleBlock';
import AudioPlayer from '../components/Media/AudioPlayer';
import YoutubePlayer from '../components/Media/YoutubePlayer';
import ImageSwiper from '../components/Media/ImageSwiper';
import Tabs from '../components/Tabs';
import { getNoteDetail, NoteResponse } from '../api/note';

const NotePage:React.FC = () => {
  const { noteId } = useParams<{noteId:string}>();
  const [data,setData] = useState<NoteResponse['data']>();
  const [loading,setLoading] = useState(true);

  useEffect(()=>{
    if(!noteId) return;
    getNoteDetail(noteId).then(res=>{
      if(res.data.rCode===0) setData(res.data.data);
    }).finally(()=>setLoading(false));
  },[noteId]);

  if(loading) return <p style={{textAlign:'center'}}>Loading...</p>;
  if(!data) return <p>Note not found.</p>;

  const renderMedia = ()=>{
    switch(data.type){
      case 1: return <AudioPlayer src={data.urls[0]} />;
      case 2: return <YoutubePlayer url={data.urls[0]} />;
      case 3: return <ImageSwiper urls={data.urls} />;
      default: return null;
    }
  };

  return (
    <>
      <Header/>
      <main className="note-page">
        <TitleBlock title={data.name} date={data.createTime}/>
        {renderMedia()}
        <Tabs summary={data.summary}
          transcription={data.transcription}
          insight = {data.bookmark}
         />
      </main>
    </>
  );
};
export default NotePage;

